export default class BookingSummaryRealignmentService {

    constructor() {
        this.eventDelegation();
    }

    eventDelegation() {
        const bookingSummary = document.querySelector('#reservation-summary');
        if (!bookingSummary) {
            return;
        }

        let container;
        if (window.matchMedia("(max-width: 991px)").matches) {
            container = document.querySelector('[data-entity=book-summary-xs]');
        } else {
            container = document.querySelector('#summary-lg');
        }

        if (container) {
            container.appendChild(bookingSummary);
        }
    }
};
